var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-danger",
    transform: "translate(0.003 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M222.867,154.7a.468.468,0,0,0-.468.468v8.852a.468.468,0,0,0,.937,0v-8.852A.468.468,0,0,0,222.867,154.7Zm0,0",
    transform: "translate(-212.151 -147.458)",
    fill: "#be0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38152",
    "data-name": "Path 38152",
    d: "M104.867,154.7a.468.468,0,0,0-.468.468v8.852a.468.468,0,0,0,.937,0v-8.852A.468.468,0,0,0,104.867,154.7Zm0,0",
    transform: "translate(-99.589 -147.458)",
    fill: "#be0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38153",
    "data-name": "Path 38153",
    d: "M1.307,5.953v11.54a2.606,2.606,0,0,0,.677,1.782A2.256,2.256,0,0,0,3.632,20h8.729a2.255,2.255,0,0,0,1.648-.724,2.606,2.606,0,0,0,.677-1.782V5.953a1.792,1.792,0,0,0-.452-3.519H11.872V1.849A1.855,1.855,0,0,0,11.34.536,1.8,1.8,0,0,0,10.045,0h-4.1A1.8,1.8,0,0,0,4.654.536a1.855,1.855,0,0,0-.532,1.313v.585H1.759a1.792,1.792,0,0,0-.452,3.519ZM12.361,19.062H3.632a1.475,1.475,0,0,1-1.4-1.569V5.994H13.764v11.5A1.475,1.475,0,0,1,12.361,19.062ZM5.044,1.849A.909.909,0,0,1,5.306,1.2.882.882,0,0,1,5.948.936h4.1a.882.882,0,0,1,.642.263.908.908,0,0,1,.262.651v.585H5.044ZM1.759,3.371H14.234a.843.843,0,0,1,0,1.686H1.759a.843.843,0,0,1,0-1.686Zm0,0",
    transform: "translate(0 0)",
    fill: "#be0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38154",
    "data-name": "Path 38154",
    d: "M163.867,154.7a.468.468,0,0,0-.468.468v8.852a.468.468,0,0,0,.937,0v-8.852A.468.468,0,0,0,163.867,154.7Zm0,0",
    transform: "translate(-155.87 -147.458)",
    fill: "#be0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDanger);
export default __webpack_public_path__ + "static/media/delete-danger.cfe6f3ea.svg";
export { ForwardRef as ReactComponent };